export default __webpack_public_path__ + "media/line-bg.a99f6a5c.png";